import { useIntl } from 'react-intl';
import { useTheme } from '@mui/material';
import { TbIcon } from 'components/Figma/TbIcon';
import { cn } from 'utils/classNamesTailwind';
import './Trigger.css';

export interface TriggerProps {
  caption: string;
  displayValue: string;
  open: boolean;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  fullWidth?: boolean;
}

export function Trigger({
  caption,
  displayValue,
  open,
  disabled = false,
  onClick,
  className = undefined,
  fullWidth = false,
}: TriggerProps) {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <fieldset
      className={cn(
        'trigger-fieldset',
        open && 'trigger-open',
        disabled && 'trigger-disabled disabled',
        fullWidth && 'trigger-full-width',
        className
      )}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={(disabled ?? open) ? undefined : onClick}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick(e as unknown as React.MouseEvent<HTMLElement>);
        }
      }}
      style={{
        color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
      }}
    >
      <legend>{intl.formatMessage({ id: caption, defaultMessage: caption })}</legend>
      <div
        className={cn('trigger-content', disabled && 'trigger-content-disabled')}
        style={{ color: disabled ? theme.palette.text.disabled : theme.palette.text.primary }}
      >
        {disabled ? (
          <TbIcon name="LockClosed" size="md" className="mr-2" />
        ) : (
          <TbIcon name="Calendar" className="mr-2 " />
        )}
        <span className="normal-case truncate">{displayValue}</span>
      </div>
    </fieldset>
  );
}
